import { SVGProps, cloneElement } from "react";

import { AtlassianLogoBrandV2 } from "./logos/atlassianv2-logo-brand";
import { AtlassianMarkBrandV2 } from "./logos/atlassianv2-mark-brand";
import { BitbucketMarkBrandV2 } from "./logos/bitbucketv2-mark-brand";
import { CompassMarkBrandV2 } from "./logos/compassv2-mark-brand";
import { ConfluenceMarkBrandV2 } from "./logos/confluencev2-mark-brand";
import { JiraProductDiscoveryMarkBrandV2 } from "./logos/jiraproductdiscoveryv2-mark-brand";
import { JiraServiceManagementMarkBrandV2 } from "./logos/jiraservicemanagementv2-mark-brand";
import { JiraMarkBrandV2 } from "./logos/jirav2-mark-brand";
import { LoomMarkBrandV2 } from "./logos/loom-mark-brand";
import { TrelloMarkBrandV2 } from "./logos/trellov2-mark-brand";

export type LogoBrandV2 =
    | "atlassian"
    | "bitbucket"
    | "compass"
    | "confluence"
    | "jira"
    | "jiraproductdiscovery"
    | "jiraservicemanagement"
    | "trello"
    | "loom"
    | "guard";

export interface LogoPropsV2
    extends Pick<SVGProps<SVGSVGElement>, "height" | "width"> {
    type: "logo" | "mark";
    appearance: "brand" | "inverse" | "neutral";
    brand: LogoBrandV2;
}

type LogoAppearance = {
    brand: JSX.Element;
    inverse?: JSX.Element;
    neutral?: JSX.Element;
};

type LogoType = {
    mark?: LogoAppearance;
    logo?: LogoAppearance;
};

type Logos = { [key in LogoBrandV2]: LogoType };

const Logos: Logos = {
    atlassian: {
        mark: {
            brand: <AtlassianMarkBrandV2 />
        },
        logo: {
            brand: <AtlassianLogoBrandV2 />
        }
    },
    bitbucket: {
        mark: {
            brand: <BitbucketMarkBrandV2 />
        }
    },
    compass: {
        mark: {
            brand: <CompassMarkBrandV2 />
        }
    },
    confluence: {
        mark: {
            brand: <ConfluenceMarkBrandV2 />
        }
    },
    guard: {
        mark: {
            brand: <AtlassianMarkBrandV2 />
        }
    },
    jira: {
        mark: {
            brand: <JiraMarkBrandV2 />
        }
    },
    jiraservicemanagement: {
        mark: {
            brand: <JiraServiceManagementMarkBrandV2 />
        }
    },
    jiraproductdiscovery: {
        mark: {
            brand: <JiraProductDiscoveryMarkBrandV2 />
        }
    },
    loom: {
        mark: {
            brand: <LoomMarkBrandV2 />
        }
    },
    trello: {
        mark: {
            brand: <TrelloMarkBrandV2 />
        }
    }
};

export const LogoV2 = ({
    brand,
    type,
    appearance,
    width,
    height
}: LogoPropsV2) => {
    const logo = Logos[brand]?.[type]?.[appearance];

    return logo ? cloneElement(logo, { width, height }) : logo;
};
